$R.addLang('fr', {
    'fullscreen': 'Plein écran'
});